import { Card } from '../components/Card'
import { Icon } from '../components/Icon'
import { LearnTip } from '../lib/learn-mode'
import { useTranslation } from 'react-i18next'

const SAMPLE_QUERIES = [
  'how much did we pay USPS in April?',
  'customers with deposit > $5k who haven\'t shipped in 30 days',
  'trend of DHL margin last 6 months',
  'top 10 customers by profit last 60 days, by carrier',
  'Stripe MRR by plan, monthly',
  'labels shipped to California vs Texas last month',
]

export function AskView() {
  const { t } = useTranslation()
  return (
    <div className="space-y-5">
      <Card className="p-7">
        <div className="flex items-center justify-between gap-6">
          <div>
            <div className="text-[12px] font-semibold text-ink-500 uppercase tracking-wider">{t('ask.title')}</div>
            <div className="mt-2 text-[28px] font-bold text-ink-900 leading-none">{t('ask.subtitle')}</div>
            <div className="mt-2 text-[13px] text-ink-500">
              Plain English → SQL (read-only) → chart + table. Save useful queries as reusable widgets.
            </div>
            <LearnTip>{t('ask.learn_tip')}</LearnTip>
          </div>
        </div>
      </Card>

      <Card className="p-5 border-2 border-royal-500">
        <input
          placeholder={t('ask.placeholder')}
          className="w-full text-[18px] font-medium px-2 py-2 outline-none placeholder:text-ink-400"
          disabled
        />
        <div className="mt-3 flex flex-wrap gap-2">
          {SAMPLE_QUERIES.map(q => (
            <span key={q} className="px-3 py-1.5 bg-ink-50 border border-ink-200 rounded-full text-[12px] text-ink-600 cursor-not-allowed opacity-60">
              {q}
            </span>
          ))}
        </div>
      </Card>

      <Card className="p-5 bg-amber-50 border-amber-200">
        <div className="flex items-start gap-3">
          <Icon name="info" className="w-5 h-5 text-amber-700 mt-0.5" />
          <div>
            <div className="font-semibold text-amber-900">{t('ask.scaffolded_title')}</div>
            <div className="text-[13px] text-amber-800 mt-1 leading-relaxed">
              UI is in place. The backend needs:
              <ul className="list-disc ml-5 mt-1 space-y-0.5">
                <li>Read-only Postgres user with SELECT-only permissions</li>
                <li>SQL whitelist validator (parses + rejects anything outside <code className="text-[12px] bg-white px-1 rounded">SELECT</code>)</li>
                <li>Anthropic Claude API integration to convert NL → SQL with schema context</li>
                <li>Result-shape detector for chart auto-selection (bar vs line vs scatter)</li>
                <li>Audit log table for every query run (who, what, when)</li>
                <li>Saved-queries table (<code className="text-[12px] bg-white px-1 rounded">user_saved_queries</code>) and a route to schedule them</li>
              </ul>
              Route: <code className="text-[12px] bg-white px-1.5 py-0.5 rounded ml-1">POST /api/ask</code>.
            </div>
          </div>
        </div>
      </Card>
    </div>
  )
}
